import styles from "./spinner.module.css";

type LoaderProps = {
  width?: string;
  height?: string;
  className?: string;
};

const Loader = ({ width, height, className }: LoaderProps) => {
  return (
    <div
      className={`${styles.loaderWrapper} ${className}`}
      style={{
        width: width ? width : "25px",
        height: height ? height : "25px"
      }}>

      <svg className={styles.circularLoader} viewBox='25 25 50 50'>
        <circle
          className={styles.loaderPath}
          cx='50'
          cy='50'
          r='20'
          fill='none'
          stroke='currentColor'
          strokeWidth='2' />

      </svg>
    </div>);

};

export default Loader;